import {
  RootState,
  useAppDispatch,
  useAppSelector,
  setSelectedView,
  CompetitionViewEnum,
} from "@hypexone/uicore";
import { competitionViewMenuOptions } from "../../../utils/constants/header.constants";
import { EventFilterCounts } from "../../../utils/helpers/eventFilters";
import FilterIconWhite from "../../../assets/icons/filter-icon-white.svg";
import MenuComponent from "./MenuComponent";
import { useState } from "react";
import { isDesktop, isMobile } from "react-device-detect";
import { useLocation } from "react-router-dom";
import { IN_PLAY_ROUTE } from "@hypexone/uicore";
import Cricket from "../../../assets/images/sports_svgs/cricket_svg.svg";
import Football from "../../../assets/images/sports_svgs/football_svg.svg";
import Tennis from "../../../assets/images/sports_svgs/tennis_svg.svg";
import Casino from "../../../assets/images/sports_svgs/casino_svg.png";
import HorseRacing from "../../../assets/images/sports_svgs/horse_racing_svg.svg";
import GreyhoundRacing from "../../../assets/images/sports_svgs/greyhound_svg.png";
import Binary from "../../../assets/images/sports_svgs/binary_svg.png";
import Politics from "../../../assets/images/sports_svgs/politics_svg.png";
import Basketball from "../../../assets/images/sports_svgs/basketball_svg.png";
import Baseball from "../../../assets/images/sports_svgs/baseball_svg.png";
import TableTennis from "../../../assets/images/sports_svgs/tableTennis_svg.png";
import Volleyball from "../../../assets/images/sports_svgs/volleyball_svg.png";
import IceHockey from "../../../assets/images/sports_svgs/icehockey_svg.png";
import MMA from "../../../assets/images/sports_svgs/martialArts_svg.png";
import Rugby from "../../../assets/images/sports_svgs/rugby_svg.png";
import Darts from "../../../assets/images/sports_svgs/darts_svg.png";
import futsal from "../../../assets/images/sports_svgs/futsal_svg.png";
// import SCockfight from "../../../assets/icons/popular-sports-icons/s-cockfight.svg";
interface LiveVirtualFilterProps {
  pageTitle?: string;
  hasViewByButton?: boolean;
  isLive?: boolean;
  isVirtual?: boolean;
  isPremium?: boolean;
  /** Matches behind each button, shown next to its label. */
  counts?: EventFilterCounts;
  onFilterChange: any;
}

const LiveVirtualFilter: React.FC<LiveVirtualFilterProps> = ({
  pageTitle,
  hasViewByButton = true,
  isLive,
  isVirtual,
  isPremium,
  counts,
  onFilterChange,
}) => {
  const pathName = useLocation().pathname;
  const { selectedView } = useAppSelector((state: RootState) => state.catalog);

  const dispatch = useAppDispatch();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isInplayRoute = pathName === `${IN_PLAY_ROUTE}`;

  const handleLiveChange = () => {
    onFilterChange(!isLive, isVirtual, isPremium);
  };

  const handleVirtualChange = () => {
    onFilterChange(isLive, !isVirtual, isPremium);
  };

  const handlePremiumChange = () => {
    onFilterChange(isLive, isVirtual, !isPremium);
  };

  // One definition per button so all three keep identical sizing. Sky-style:
  // a light button told apart by its text colour. While active it fills with
  // a darker shade of that colour, white text, pressed in, so the selection is
  // obvious at a glance (a grey press alone was too faint to read).
  const filterPills = [
    {
      key: "live",
      isActive: isLive,
      onToggle: handleLiveChange,
      color: "text-[#508d0e]",
      activeColor: "from-[#3f7209] to-[#5a9c12]",
    },
    {
      key: "virtual",
      isActive: isVirtual,
      onToggle: handleVirtualChange,
      color: "text-[#2789ce]",
      activeColor: "from-[#1a6aa6] to-[#2b8ad3]",
    },
    {
      key: "premium",
      isActive: isPremium,
      onToggle: handlePremiumChange,
      color: "text-[#d77319]",
      activeColor: "from-[#b05a0c] to-[#d77319]",
    },
  ];

  const { langData } = useAppSelector((state) => state.cms);
  const sportImages: { [key: string]: string } = {
    cricket: Cricket,
    football: Football,
    tennis: Tennis,
    casino: Casino,
    horseracing: HorseRacing,
    greyhoundracing: GreyhoundRacing,
    binary: Binary,
    politics: Politics,
    basketball: Basketball,
    baseball: Baseball,
    tabletennis: TableTennis,
    volleyball: Volleyball,
    icehockey: IceHockey,
    futsal: futsal,
    mma: MMA,
    rugby: Rugby,
    darts: Darts,
    // cockfight: SCockfight,
  };

  const normalizeTitle = (title: string) =>
    title?.toLowerCase().replace(/\s+/g, "");

  return (
    <>
      <div
        className={`flex items-center gap-3 md:mt-0 mt-[2px] py-1 text-[14px] md:text-[13px] text-white px-2 ${
          pageTitle ? "justify-between" : "justify-end"
        } max-md:bg-section-gradient md:bg-goldenYellow md:text-black`}
      >
        {/* Page Title */}
        {pageTitle && (
          <div className="font-bold flex gap-1 items-center">
            {isDesktop && (
              <img
                src={sportImages[normalizeTitle(pageTitle)] || ""}
                alt={pageTitle}
                className="w-4 h-4 object-contain max-md:invert"
              />
            )}{" "}
            {pageTitle}
          </div>
        )}

        {/* Conditionally render the LiveVirtualFilter only if IsOnlyTitle is false */}
        {
          <div className="flex flex-row items-center gap-2">
            <div className="flex items-center gap-2">
              {filterPills.map(({ key, isActive, onToggle, color, activeColor }) => (
                <button
                  type="button"
                  key={key}
                  aria-pressed={!!isActive}
                  className={`flex items-center justify-center min-w-16 px-3 py-[3px] rounded-[4px] text-[12px] font-bold leading-[16px] cursor-pointer bg-gradient-to-b ${
                    isActive
                      ? `${activeColor} text-white shadow-[inset_0_1px_3px_rgba(0,0,0,0.5)]`
                      : `from-white to-[#eee] ${color} shadow-[0_1px_1px_rgba(0,0,0,0.3)]`
                  }`}
                  onClick={onToggle}
                >
                  {langData?.[key]}
                  {counts && ` (${counts[key as keyof EventFilterCounts]})`}
                </button>
              ))}
            </div>

            {hasViewByButton && (
              <div className="relative max-md:hidden">
                <MenuComponent
                  menuTitle="View by"
                  menuList={
                    <div className="flex flex-col gap-1">
                      {competitionViewMenuOptions.map((menuItem) => {
                        return (
                          <div
                            key={menuItem}
                            className={`flex justify-center text-xs px-8 cursor-pointer py-1.5 rounded-md font-bold ${
                              menuItem === selectedView
                                ? "bg-red6 text-white"
                                : "text-black hover:bg-gray1"
                            }`}
                            onClick={() => dispatch(setSelectedView(menuItem))}
                          >
                            {menuItem}
                          </div>
                        );
                      })}
                    </div>
                  }
                  customImage={{
                    imagePosition: "left",
                    imageSrc: FilterIconWhite,
                  }}
                  customButtonCss="text-xs capitalize md:border md:rounded-2xl md:border-black"
                  toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
                  isOpen={isMenuOpen}
                  closeMenu={() => setIsMenuOpen(false)}
                />
              </div>
            )}
          </div>
        }
      </div>
      {!isInplayRoute && (
        <div className="flex flex-col justify-center items-center md:hidden">
          <div className="bg-gray-300 rounded-md flex w-[75%]">
            <div
              className={`bg-gray-300 text-nowrap text-center w-full text-[13px] rounded-md py-2 font-semibold ${
                selectedView === CompetitionViewEnum.COMPETITION
                  ? "bg-white text-blue-500 m-0.5"
                  : "bg-gray-300"
              }`}
              onClick={() =>
                dispatch(setSelectedView(CompetitionViewEnum.COMPETITION))
              }
            >
              By Competition
            </div>
            <div
              className={`text-nowrap text-center w-full text-[13px] rounded-md py-2 font-semibold ${
                selectedView === CompetitionViewEnum.TIME
                  ? "bg-white text-blue-500 m-0.5"
                  : "bg-gray-300"
              }`}
              onClick={() =>
                dispatch(setSelectedView(CompetitionViewEnum.TIME))
              }
            >
              By Time
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LiveVirtualFilter;
